import { type ErrorEvent } from '@sentry/vue'

/**
 * Ignore all errors whose referer is a legacy URL
 */
export default function filterLegacyErrors(error: ErrorEvent) {
  return !error.request?.headers?.Referer?.includes('/legacy')
}
